import { Component, OnInit, AfterViewChecked, NgZone, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/finally';
import { Subscription } from 'rxjs/Subscription';
import { ToastService } from 'libs/mdbootstrap/typescripts/pro';
import * as Models from 'app/core/models';
import { ProcessService } from 'app/core/process/process.service';
import { AuthenticationService } from 'app/core/authentication/authentication.service';
import { ModalService } from 'app/modal/modal.service';
import { UserService } from 'app/core/user/user.service';
import { LookupService } from 'app/core/lookup/lookup.service';
import {TranslateService} from '@ngx-translate/core';
import {Title} from '@angular/platform-browser';
import {PageTitleService} from '../shared/helpers/pageTitle.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewChecked, OnDestroy {

  public ProcessGroups: any = Models.ProcessGroups;
  groups: Models.ProcessGroup[];
  tagCategoryGroups: Models.TagCataegoryGroup[] = [];
  tagCategories: Models.TagCategory[];
  processPerSlides = 3;
  checkQueriesDone = false;
  myProcesses: Array<Models.Process>;
  loadingMyProcesses = false;
  createdByImageUrl: boolean;
  private autenicationSunscribtion: Subscription;
  private NUMBER_OF_MY_PROCESSES = 4;
  private NUMBER_OF_CARDS_IN_CAROUSEL = 12;

  constructor(private processService: ProcessService,
              private authenticationService: AuthenticationService,
              private router: Router,
              private actRoute: ActivatedRoute,
              private modalService: ModalService,
              private ngZone: NgZone,
              private toastService: ToastService,
              private userService: UserService,
              private lookupService: LookupService,
              private pageTitleService: PageTitleService) {

    window.onresize = (e) => {
      this.onResize();
    };
  }

  ngOnInit() {
    
    this.getData();

    // My Processes
    this.autenicationSunscribtion = this.authenticationService.authenticationStatusChange$.subscribe(isAuthenicated => {
      if (isAuthenicated) {
        this.getMyProcesses();
        this.getData();
      } else {
        this.myProcesses = [];
        this.getData();
      }
    });

    this.pageTitleService.setTitle(this.actRoute.data['value'].titleKey);
  }

  getData(): void{
    this.processPerSlides = this.calculateProcessPerSlide();

    // Tag Categories
    this.getTagCategories();

    // Home Groups
    this.groups = [
      <Models.ProcessGroup>{ group: Models.ProcessGroups.Recents, groupTitle: 'HOME.HOME_RECENTS' },
      <Models.ProcessGroup>{ group: Models.ProcessGroups.Executions, groupTitle: 'HOME.HOME_EXECUTIONS' },
      <Models.ProcessGroup>{ group: Models.ProcessGroups.Views, groupTitle: 'HOME.HOME_VIEWS' },
      <Models.ProcessGroup>{ group: Models.ProcessGroups.Likes, groupTitle: 'HOME.HOME_LIKES' },
    ];
    for (const entry of this.groups) {
      entry.isLoading = true;
      this.processService.getGroups(entry.group, this.NUMBER_OF_CARDS_IN_CAROUSEL)
        .finally(() => { entry.isLoading = false; })
        .subscribe((group: Models.PagedList<Models.Process>) => {
          entry.slides = this.createSlide(group.items, this.processPerSlides);
        });
    }
    if (this.isAuthenticated) {
      this.getMyProcesses();
    }
  }

  ngAfterViewChecked() {
    if (!this.checkQueriesDone) {
      this.checkQueriesDone = true;
      const userId: string = this.router.routerState.snapshot.root.queryParams['userId'];
      const confirmEmailToken: string = this.router.routerState.snapshot.root.queryParams['confirmEmailToken'];
      const resetPasswordToken: string = this.router.routerState.snapshot.root.queryParams['resetPasswordToken'];

      if (userId && confirmEmailToken) {
        this.confirmEmail({ userId: userId, token: confirmEmailToken });
      } else if (userId && resetPasswordToken) {
        const data: Models.ModalContext = {
          modalType: Models.ModalType.RESET_PASSWORD,
          modalAction: Models.ModalAction.OPEN,
          parameters: [userId, resetPasswordToken]
        };
        this.modalService.command(data);
      }
    }
  }

  ngOnDestroy(): void {
    this.autenicationSunscribtion.unsubscribe();
  }

  get isAuthenticated(): boolean {
    return this.authenticationService.isAuthenticated();
  }

  get hasUserDetails(): boolean {
    return this.userService.hasUserDetais;
  }

  get isAuthenticatedAndHasUserDetails(): boolean {
    return this.isAuthenticated && this.hasUserDetails;
  }

  get userFullName(): string {
    return this.userService.userFullName;
  }

  createSlide(items: any[], itemsPerSlide: number): any[][] {
    const result: any[][] = [];
    items.forEach(element => {
      element.color = this.randomColor();
      element.createdByInitials = element.createdBy ? element.createdBy
        .split(' ')
        .map((n: string) => n.substr(0, 1))
        .slice(0, 2).join('') : '';
    });
    while (items.length > 0) {
      result.push(items.splice(0, itemsPerSlide));
    }
    return result;
  }

  getMyProcesses(): void {
    this.loadingMyProcesses = true;
    this.processService.getMyProcesses(this.NUMBER_OF_MY_PROCESSES)
      .finally(() => {
        this.loadingMyProcesses = false;
      })
      .subscribe((myProcesses: Models.Process[]) => {
        myProcesses.forEach(element => {
          element.color = this.randomColor();
          element.createdByInitials = element.createdBy ? element.createdBy.
          split(' ').
          map((n: string) => n.substr(0, 1)).
          slice(0, 2).join('') : '';
        });
        this.myProcesses = myProcesses;
      });
  }

  confirmEmail(data: Models.EmailConfirmation): void {
    const modalData: Models.ModalContext = {
      modalType: Models.ModalType.CONFIRM_EMAIL,
      modalAction: Models.ModalAction.OPEN,
      parameters: [data]
    };
    this.modalService.command(modalData);
  }

  randomColor(): string {
    return (Math.floor(Math.random() * (6)) + 1).toString();
  }

  calculateProcessPerSlide(): number {
    const width = window.innerWidth;
    let newprocessPerSlides;
    if (width >= 1200) {
      newprocessPerSlides = 3;
    } else if (width >= 500) {
      newprocessPerSlides = 2;
    } else {
      newprocessPerSlides = 1;
    }
    return newprocessPerSlides;
  }

  onResize() {
    const newprocessPerSlides = this.calculateProcessPerSlide();

    if (newprocessPerSlides !== this.processPerSlides) {
      this.processPerSlides = newprocessPerSlides;
      for (const group of this.groups) {
        group.slides = this.createSlide([].concat.apply([], group.slides), this.processPerSlides);
      }

      for (const group of this.tagCategoryGroups) {
        group.slides = this.createSlide([].concat.apply([], group.slides), this.processPerSlides);
      }
    }
  }

  preview(processId: number, processName?: string) {
    if (!this.isAuthenticated) {
      const data: Models.ModalContext = {
        modalType: Models.ModalType.SIGN_UP,
        modalAction: Models.ModalAction.OPEN,
        parameters: []
      };
      this.modalService.command(data);
    } else {
      if (processName.trim()) {
        this.router.navigate(['/process/preview/', processId, processName]);
      } else {
        this.router.navigate(['/process/preview/', processId]);
      }
    }
  }

  run($event: Event, processId: number) {
    $event.stopPropagation();
    if (!this.isAuthenticated) {
      const data: Models.ModalContext = {
        modalType: Models.ModalType.SIGN_UP,
        modalAction: Models.ModalAction.OPEN,
        parameters: []
      };
      this.modalService.command(data);
    } else {
      this.router.navigate(['/process/execute/', processId]);
    }
  }

  goToCatgory(group: Models.ProcessGroups, tagid?: number): void {
    if (!tagid) {
      this.router.navigate(['/process/processCategories/', group]);
    } else {
      this.router.navigate(['/process/processCategories/', group, tagid]);
    }
  }

  edit($event: Event, processId: number) {
    $event.stopPropagation();
    if (!this.isAuthenticated) {
      const data: Models.ModalContext = {
        modalType: Models.ModalType.SIGN_UP,
        modalAction: Models.ModalAction.OPEN,
        parameters: []
      };
      this.modalService.command(data);
    } else {
      this.router.navigate(['/process/editing/', processId]);
    }
  }

  getTagCategories(): void {
    this.tagCategories = [];
    this.tagCategoryGroups = [];
    this.lookupService.getTagCategories()
      .finally(() => {

      })
      .subscribe((tagCategories: Array<Models.TagCategory>) => {
        tagCategories.forEach(category => {
          this.processTagCategory(category);
        });
      });
  }

  processTagCategory(category: Models.TagCategory): void {
    const tagCategoryGroup: Models.TagCataegoryGroup = {
      groupTitle: category.categoryTitle,
      tagId: category.tagId,
      items: [],
      slides: [],
      isLoading: true
    };

    this.tagCategoryGroups.push(tagCategoryGroup);

    tagCategoryGroup.isLoading = true;
    this.processService.getTagCategoryProcesses(category.tagId, this.NUMBER_OF_CARDS_IN_CAROUSEL)
      .finally(() => {
        tagCategoryGroup.isLoading = false;
      })
      .subscribe((group: Models.PagedList<Models.Process>) => {
        tagCategoryGroup.items = group.items;
        tagCategoryGroup.slides = this.createSlide(group.items, this.processPerSlides);
      });
  }

}






// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/home/home.component.ts